import {
  ButtonsWrapper,
  CancelButton,
  ModalCloseButton,
  ModalCloseIcon,
  ModalContent,
  ModalExclamationIcon,
  ModalWrapper,
  Title,
} from '../../../shared/DeleteConfirmationModal/DeleteConfirmationModal.styled';
import { DeleteProductCTA, ImageContainer, UnderProductWrapper } from './DeleteProductOnCart.styled';
import {
  Description,
  Wrapper,
} from '../../../components/ProductDetail/ProductDetail.styled';
import { useState } from 'react';
import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import { Anchor } from '../../../shared/Anchor';
import { Button } from '../../../shared';
import Image from 'next/image';
import type { ProductType } from '../../../types/product';
import { deleteProductCart } from '../../../api/cart';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { setCart } from '../../../store/cart/cartSlice';
import type { state } from '../../../types/store/state';
import { useTranslation } from 'next-i18next';
import { handleToastAsyncAction } from '../../../utils/handleToastAsyncAction';
import * as Sentry from '@sentry/react';

export const DeleteProductOnCart = (props: ProductType) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const cartReference = useSelector((state: state) => state.cart.reference);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  const handleConfirmModal = () => {
    setConfirmDeleteModal(!confirmDeleteModal);
  };

  const handleDelete = async () => {
    const paramsToSend = props.product.isDish
      ? { orderBranchProduct: props.id }
      : { storeBranchProduct: props.product.storeBranchProductId };

    const result = await handleToastAsyncAction(
      () => deleteProductCart({
        id: cartReference,
        params: paramsToSend,
      }),
      {
        onSuccessMessage: t('cart.product.delete.toastify.success', { 
          productName: props.product.name 
        }),
        onErrorMessage: t('cart.product.delete.toastify.error', { 
          productName: props.product.name 
        }),
        dispatchAction: () => {
          setConfirmDeleteModal(false);
        },
        errorLogger: (error) => {
          console.error('Error deleting product from cart:', error);
          Sentry.captureException(error, {
            tags: {
              action: 'delete_product_cart',
              cartReference,
              productId: props.id,
              isDish: props.product.isDish
            },
            extra: {
              productName: props.product.name,
              params: paramsToSend
            }
          });
        },
      }
    );

    if (result.success && result.data) {
      dispatch(setCart(result.data));
    }
  };

  return (
    <UnderProductWrapper>
      <DeleteProductCTA>
        <Anchor
          title={t('cart.shared.action.deleteProduct')}
          onClick={handleConfirmModal}
          icon={faTrashAlt}
          size="small"
          variation="secondary"
        />
      </DeleteProductCTA>
      {confirmDeleteModal ? (
        <ModalWrapper>
          <ModalContent>
            <ModalCloseButton onClick={handleConfirmModal}>
              <ModalCloseIcon icon={faTimes} />
            </ModalCloseButton>
            <Wrapper>
              <ModalExclamationIcon icon={faExclamationCircle} />
              <Title>{t('addresses.deleteModal.title')}</Title>
              <Description>
                {t('cart.product.deleteModal.description')}
                <ImageContainer>
                  <Image
                    src={props.product.images[0].image}
                    alt={props.product.name}
                    layout="fill"
                    objectFit="contain"
                  />
                </ImageContainer>
                <span>{props.product.name}</span>
              </Description>
              <ButtonsWrapper>
                <Button
                  title={t('cart.product.deleteModal.cta.confirm')}
                  onClick={handleDelete}
                />
                <CancelButton
                  title={t('cart.product.deleteModal.cta.cancel')}
                  type="reset"
                  onClick={() => setConfirmDeleteModal(false)}
                />
              </ButtonsWrapper>
            </Wrapper>
          </ModalContent>
        </ModalWrapper>
      ) : null}
    </UnderProductWrapper>
  );
};